import React from "react";
import OwnerPageIndexList from "containers/owner/page/OwnerPageIndexList";
import { Modal } from "react-bootstrap";
import { createElementIdFactory } from "utils/elementIds";

function OwnerPageIndexModal({
    user,
    onClose,
    data = [],
    ownerid,
    updateTableState,
    saveRecord,
    show,
}) {
    const createId = createElementIdFactory("owner-page-index-modal");

    return (
        <Modal id={createId("modal")} show={show} onHide={onClose} size="xl" centered>
            <Modal.Header id={createId("header")} closeButton>
                <Modal.Title>Owner Index</Modal.Title>
            </Modal.Header>
            <Modal.Body id={createId("body")}>
                <OwnerPageIndexList
                    controlType="table"
                    user={user}
                    data={data}
                    ownerid={ownerid}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                />
            </Modal.Body>
        </Modal>
    );
}
export default OwnerPageIndexModal;